import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(protected sanitizer: DomSanitizer) {}

    public transform(value: string): SafeHtml {
        const sanitizedContent: string | null = this.sanitizer.sanitize(SecurityContext.HTML, value);
        return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent ?? '');
    }
}
